import { IconLatestResearch } from '@medifind/icons';
import { useRouter } from '@medifind/router';
import { selectRouteParams, useRouteStore } from '@medifind/zustand';
import AdWrapper from './adWrapper';

const LatestAdvancesAd = ({ projectId, codingSlug, ...props }) => {
  const router = useRouter();
  const { query } = router;
  const { projectId: queryProjectId, codingSlug: queryCodingSlug } = query || {};
  const { codingType } = useRouteStore(selectRouteParams);
  return projectId || queryProjectId ? (
    <AdWrapper
      {...props}
      icon={<IconLatestResearch showBackground={false} showBoxShadow={false} width={41} height={50} color={'#645da2'} padding={false} />}
      title={'Tired of the same old research?'}
      onClick={() =>
        router.history.push(
          `/${codingType === 'procedure' ? 'procedures' : 'conditions'}/${codingSlug || queryCodingSlug}/${
            projectId || queryProjectId
          }/treatment-advances`,
        )
      }
      buttonText={'Check Latest Advances'}
    />
  ) : null;
};

export { LatestAdvancesAd as default, LatestAdvancesAd };
